<template>
  <div class="container px-8 pt-8 mx-auto lg:px-16">
    <h2 class="text-4xl font-bold tracking-wider uppercase font-raleway">Le collier</h2>
    <hr class="mb-10 antialiased border border-green-500" />

    <!-- <img
      src="@/assets/img/collierDetails.png"
      alt="Collier HerdingCats de face"
    /> -->
    <div class="w-full lg:px-24">
      <VueCompareImage
        class="mt-8 mb-8"
        leftImage="img/closed0001.jpg"
        rightImage="img/open0001.jpg"
      />
    </div>

    <div class="text-center">
      <a
        href="#"
        v-scroll-to="'#soutenir'"
        class="inline-block px-8 py-4 font-bold tracking-wider text-white uppercase bg-green-500 rounded-full shadow-md hover:bg-green-400 hover:shadow-lg"
      >En savoir plus</a>
    </div>
  </div>
</template>

<script>
import VueCompareImage from 'vue-compare-image';

export default {
  name: "Collier",
  components: {
    VueCompareImage
  }
  // props: {
  //   isGpsEnabled: {
  //     default: true,
  //     type: Boolean
  //   }
  // }
};
</script>

<style>
</style>